module.exports = __webpack_public_path__ + "static/media/anthropic_logo.72d2be4d.png";